import React, { useState } from 'react'
import { Autocomplete, Box, Button, Grid, IconButton, InputAdornment, TextField, makeStyles } from '@material-ui/core';
import SearchIcon from '../../../icons/Search'
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router';
import { useTheme } from '@material-ui/core';
import useAuth from '../../../hooks/useAuth';

const useStyles = makeStyles((theme) => ({
  searchInput: {
    backgroundColor: '#fff',
    borderRadius: 5,
  },
  lengthSelect: {
    borderRadius: 5,
  },
  browseButton: {
    borderRadius: 5,
  },
}))

const times = [
  {
    title: ':15',
    value: '15'
  },
  {
    title: ':30',
    value: '30'
  },
  {
    title: ':60',
    value: '60'
  },
]

const AlternateHomeSearch = (props) => {
  const { size, categories, handleSearch } = props
  const classes = useStyles()
  const theme = useTheme()
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()


  if (theme.name != "AudacyFlash" && theme.name != "CreativeLove") return null

  console.log(isAuthenticated)

  return (
    <Grid container spacing={2} sx={{ mt: 6 }}>
      {isAuthenticated ? (

        <Grid item md={4} sm={6} xs={12} sx={{ mb: 4 }}>
          <Box>
            <Box sx={{ mb: 8, display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
              <img src={theme.logo} width={theme.name == "AudacyFlash" ? "200px" : "240px"} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <Button
                variant="contained"
                size="large"
                sx={{ backgroundColor: theme.name == "AudacyFlash" ? theme.palette.primary.accent : theme.palette.primary.main, px: 8, mb: 3 }}
                onClick={() => navigate('/concierge/12')}
              >
                Specs
              </Button>
              <Button
                variant="contained"
                size="large"
                sx={{ backgroundColor: theme.name == "AudacyFlash" ? theme.palette.primary.accent : theme.palette.primary.main, px: 6.5, mb: 3 }}
                onClick={() => navigate('/concierge/13')}
              >
                Customs
              </Button>
              <Button
                variant="contained"
                size="large"
                sx={{ backgroundColor: theme.name == "AudacyFlash" ? theme.palette.primary.accent : theme.palette.primary.main, px: 7, mb: 3 }}
                onClick={() => navigate('/concierge/14')}
              >
                Digitals
              </Button>
            </Box>
          </Box>
        </Grid>
      ) : (
        <Grid item md={4} sm={6} xs={12} sx={{ mb: 4 }}>
          <Box>
            <Box sx={{ mb: 8, display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
              <img src={theme.logo} width={theme.name == "AudacyFlash" ? "200px" : "240px"} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <Button
                variant="contained"
                size="large"
                sx={{ backgroundColor: theme.palette.primary.main, px: 8, mb: 3, textTransform: 'uppercase' }}
                style={{ borderRadius: 30 }}
                onClick={() => navigate('/authentication/login')}
              >
                Log in
              </Button>
            </Box>
          </Box>
        </Grid>
      )}


    </Grid>
  )
};

export default AlternateHomeSearch;
